import { useContext } from 'react';
import { TryItOutContext, TryItOutContextValue } from '../context/TryItOutProvider';

export const useTryItOut = (): TryItOutContextValue => {
  const context = useContext(TryItOutContext);

  if (!context) {
    throw new Error('useTryItOut must be used within a TryItOutProvider');
  }

  return context;
};

export default useTryItOut;
